import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import Lightbox from "yet-another-react-lightbox";
import loading from '../assets/images/loading-buffering.gif';
import "yet-another-react-lightbox/styles.css";

import default_profile from "../assets/images/default_profile.png";

import { getSizedImageUrl } from "../utils/getSizedImageUrl";

type Photo = {
  picture: string;
  orignal_picture: string;
};

type User = {
  pic?: string;
};

type Props = {
  backgroundPhotos: Photo[];
  user: User;
};

const ProfileCarousel: React.FC<Props> = ({ backgroundPhotos = [], user }) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
  let isCancelled = false;

  const loadImages = async () => {
    // If backgroundPhotos is undefined or still loading, exit early
    if (!Array.isArray(backgroundPhotos)) return;

    setImages([]); // Clear old images

    if (backgroundPhotos.length > 0) {
      const tempLoading = backgroundPhotos.map(() => loading);
      setImages(tempLoading);

      await new Promise(resolve => setTimeout(resolve, 500));

      const thumbs = await Promise.all(
        backgroundPhotos.map(async (photo) => {
          const thumbUrl = await getSizedImageUrl(photo.picture, "389x438");
          return thumbUrl || photo.orignal_picture || default_profile;
        })
      );

      if (!isCancelled) {
        setImages(thumbs);
      }
    } else {
      // Only fallback if user is fully loaded and backgroundPhotos are truly empty
      if (!isCancelled && user?.pic) {
        setImages([user.pic]);
      } else {
        setImages([default_profile]);
      }
    }
  };

  loadImages();

  return () => {
    isCancelled = true;
  };
}, [backgroundPhotos, user]);

  const originalImages = backgroundPhotos.length
    ? backgroundPhotos.map((photo) => photo.orignal_picture)
    : [user.pic ?? default_profile];

  const slides = originalImages.map((src) => ({ src }));

  return (
    <>
      <Carousel className="dating_profile_carousel">
        {images.map((src, index) => (
          <Carousel.Item key={index}>
            <img
              src={src}
              className="d-block w-100 cursor-pointer"
              alt={`User photo ${index + 1}`}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={slides}
          index={photoIndex}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
        />
      )}
    </>
  );
};

export default ProfileCarousel;
